var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.6333 28.3327H24.3667C26.6667 28.3327 27.5833 26.9243 27.6917 25.2077L28.125 18.3243C28.2417 16.5243 26.8083 14.9993 25 14.9993C24.4917 14.9993 24.025 14.7077 23.7917 14.2577L23.1917 13.0493C22.8083 12.291 21.8083 11.666 20.9583 11.666H19.05C18.1917 11.666 17.1917 12.291 16.8083 13.0493L16.2083 14.2577C15.975 14.7077 15.5083 14.9993 15 14.9993C13.1917 14.9993 11.7583 16.5243 11.875 18.3243L12.3083 25.2077C12.4083 26.9243 13.3333 28.3327 15.6333 28.3327Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.291H18.75C18.4083 17.291 18.125 17.0077 18.125 16.666C18.125 16.3243 18.4083 16.041 18.75 16.041H21.25C21.5917 16.041 21.875 16.3243 21.875 16.666C21.875 17.0077 21.5917 17.291 21.25 17.291Z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.1079C21.5556 25.1079 22.8167 23.8469 22.8167 22.2913C22.8167 20.7357 21.5556 19.4746 20 19.4746C18.4444 19.4746 17.1833 20.7357 17.1833 22.2913C17.1833 23.8469 18.4444 25.1079 20 25.1079Z",
    fill: "#475467"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#1D2939",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.92e60be161700972590eff4a8afab2f9.svg";
export { ForwardRef as ReactComponent };